import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { dialogSteps } from "../../constants/cookieConstants";

const initialState = {
  isOpen: false,
  step: dialogSteps.INITIAL,
};

const cookieSlice = createSlice({
  name: "cookie",
  initialState,
  reducers: {
    // Previous setCookieJarOpen(payload) with payload = { isOpen }
    setCookieJarOpen: (state, action: PayloadAction<{ isOpen: any }>) => {
      state.isOpen = action.payload.isOpen;
    },
    // Previous setCookieJarStep(payload) with payload = { step }
    setCookieJarStep: (state, action: PayloadAction<{ step: any }>) => {
      state.step = action.payload.step;
    },
  },
});

export const { setCookieJarOpen, setCookieJarStep } = cookieSlice.actions;

export default cookieSlice.reducer;
